<h2 mat-dialog-title class="mat-dialog-title-offset">Change timeline subject</h2>

<div class="modal-close-icon-container tw:flex tw:items-center">
  <button class="close-modal" mat-button [mat-dialog-close]="false" tabindex='-1'>
    <div class="close-modal modal-close-icon"></div>
  </button>
</div>
<mat-dialog-content class="mat-typography modal-master-container">
  <div class="tw:py-12 content-container">
    <select-timeline-subject [studentId]="data.studentId"
                             [studentName]="data.studentName"
                             [placementId]="data.placementId"
                             [clientId]="data.clientId"
                             (closeModal)="close()">
    </select-timeline-subject>
  </div>
</mat-dialog-content>
